
export default {
    methods: {
        showMessage(title,message,type){
          if (message instanceof Error) { 
            message = message?.response?.data?.errorMessage || this.$t('Msg.sError');
            type = "error";
          }

          this.$bvToast.toast(message, {
            title: title,
            solid: true,
            variant: type == 'error' || type == 'errorAutoHide'  ? 'danger' : type == 'warning' ? 'warning' : type == 'info' ? 'info' : 'success',
            autoHideDelay: 10000,
           // noAutoHide: type == 'error' ? true : false
          })
        },

        showPermissionMessage(){
          this.$bvToast.toast(this.$t('DBFunctions.mNotAllowed'), {
            title: this.$t('Msg.Permissions'),
            solid: true,
            variant: "danger",
            noAutoHide: true
          })
        },

        showWarningMessage(message, link){
          this.$bvToast.toast(message, {
            title: 'Warning',
            solid: true,
            variant: "warning",
            to: link,
            noAutoHide: true
          })
        },

        showResponseErrorMessage(error) {
            if (Object.hasOwn(error, 'response')) {
                if(!error.response) {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    return this.$t('Msg.retrieveInfo');
                } else if(error.response.status === 400) {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    return error.response.data.errorMessage;
                } else if(error.response.status === 405) {
                    this.showMessage( this.$tc('Msg.Error'), error.response.data.errorMessage, "error" ); 
                    this.$router.push({ name: 'AccessDenied' }); 
                    return error.response.data.errorMessage;
                } else if(error.response.status === 500) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                    return this.$t('Msg.ThereWereSomeError');
                } else {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    return error.response.data.errorMessage;
                }
            } else {
                this.showMessage(this.$tc('Msg.Error'), error, "error");
                return error;
            }
        }
    }
}